export default {
  getBillShopOrder: {
    method: 'get',
    url: 'bill/mch/order'
  },
  reviseBillShopOrder: {
    method: 'post',
    url: 'bill/mch/order'
  },
  getBillShopTransfer: {
    method: 'get',
    url: 'bill/mch/transfer'
  },
  getBillShopConsume: {
    method: 'get',
    url: 'bill/mch/consume'
  },
  getBillUserConsume: {
    method: 'get',
    url: 'bill/user/consume'
  },
  getBillSmsRecharge: {
    method: 'get',
    url: 'bill/sms/recharge'
  },
  handTransfer: {
    method: 'post',
    url: 'bill/mch/transfer'
  },
  createOrderTransfer: {
    method: 'post',
    url: 'bill/mch/order-transfer'
  }
}
